import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import Page from 'models/page';
import PlannedActivity from 'models/planned_activity';
import AccountProfile from 'models/account_profile';
import ActivityCollection from 'collections/activity';
import ActivityGroupCollection from 'collections/activity_group';
import PlannedActivityCollection from 'collections/planned_activity';
import Register from 'views/register';
import datenav from 'core/controllers/date_navigation';


const Video = require('views/video');

export default Backbone.View.extend({
  events: {
    'click .time-btn-group button': 'time_selected',
    'click #choose-activities-btn': 'choose_activities',
    'click .js-replace': 'replace_activity',
    'click .js-replace-all': 'replace_all_activities',
    'click .js-add': 'add_activity',
    'click .learn-more': 'learn_more_flyover',
    'click .flyover .flyover-close': 'close_flyover'
  },

  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    // Member variables
    this.choose_activities_section = $('#plan-choose-activities', this.el);
    this.activity_details = $('.activity-section', this.choose_activities_section);
    this.flyover = $('.flyover', this.el);
    this.replace_all = $('.js-replace-all', this.choose_activities_section);

    // Collections
    this.activity_group_collection = new ActivityGroupCollection();
    this.activity_collection = new ActivityCollection();
    this.planned_activity_collection = new PlannedActivityCollection();

    this.profile = new AccountProfile();
    this.activity_index = 0; // the index of the next activity to be rendered
    this.activities_per_page = 3;
    this.current_pages = new Array(this.activities_per_page);
    this.today = datenav.formatted_date(new Date());

    // Templates
    this.activity_detail_tmpl = _.template($('#activity-detail-template').html());
    this.activity_detail_added_tmpl = _.template($('#activity-detail-added-template').html());
    this.activity_flyover_tmpl = _.template($('#activity-flyover-template').html());
    this.register_flyover_tmpl = _.template($('#register-flyover-template').html());
    this.planned_3_tmpl = _.template($('#planned-3-modal-template').html());

    this.deferreds = [
      this.activity_group_collection.fetch({ cache: true, expires: 86400 }),
      this.activity_collection.fetch({ cache: true, expires: 86400 }),
      this.profile.fetch(),
      this.planned_activity_collection.fetch({ data: $.param({ date: this.today }) })
    ];
  },

  render: function () {
    if (GLOBALS.GET.register_activity_id) {
      new PlannedActivity({
        activity: API_PREFIX + window.Urls['tracker_api:api_dispatch_detail']({
          api_name: API_VERSION,
          resource_name: 'activity',
          pk: GLOBALS.GET.register_activity_id,
        }),
        date: this.today
      }).save({}, {
        success: this.get_deferreds,
        // Ignore errors, just means the activity is already planned
        error: this.get_deferreds,
      });
    }
    this.get_deferreds();
  },

  get_deferreds: function () {
    $.when.apply(this, this.deferreds).then(function () {
      this.prepare_planned_3_modal();
      this.render_activity_section();
    }.bind(this));
  },

  prepare_planned_3_modal: function () {
    $('body').append(this.planned_3_tmpl({ profile: this.profile }));
    this.planned_3_modal = $('#planned-3-modal');
    $('.js-reminders', this.planned_3_modal).on('click', this.get_reminders);
  },

  extract_id: function (url) {
    var tokens = url.split('/');
    return parseInt(tokens[tokens.length - 2]);
  },

  render_activity_section: function () {
    // If the user just finished MOS registration, show reminder settings flyover
    if (GLOBALS.GET.register_activity_id) {
      this.register_flyover({
        profile: this.profile,
        starting_slide: 1
      });
    }

    // Render already planned activities
    this.planned_activity_collection.each(function (planned, i) {
      var activity_id = this.extract_id(planned.get('activity'));
      this.render_added_activity(i, activity_id);
    }, this);

    // Render selectable activities
    this.filtered_activities = this.activity_collection.filter(function (activity) {
      return !activity.get('is_custom') &&
                  undefined === this.planned_activity_collection.findWhere(
                    { activity: activity.get('resource_uri') });
    }, this);

    // Randomize and diversify activities
    this.filtered_activities = _.shuffle(this.filtered_activities);
    var by_categories = _.groupBy(
      this.filtered_activities, function (activity) { return activity.get('group'); });
    this.filtered_activities = this.interleave.apply(this, _.values(by_categories));

    while (this.activity_index + this.planned_activity_collection.length < this.activities_per_page) {
      this.render_next_activity(this.activity_index + this.planned_activity_collection.length);
    }

  },

  interleave: function () {
    /* Takes any number of arrays as arguments, and interleaves them, returning the result */
    var arrays = [].slice.call(arguments);
    var max_len = Math.max.apply(Math, arrays.map(
      function (array) { return array.length; }));
    var result = [];

    for (var i = 0; i < max_len; i = i + 1) {
      _.each(arrays, function (array) {
        if (array.length > i) {
          result.push(array[i]);
        }
      });
    }
    return result;
  },

  render_next_activity: function (pos) {
    var activity = this.filtered_activities[this.activity_index];
    this.activity_index = (this.activity_index + 1) % this.filtered_activities.length;
    var group = this.activity_group_collection.findWhere({ resource_uri: activity.get('group') });
    $(this.activity_details[pos]).html(this.activity_detail_tmpl({
      activity: activity,
      group: group,
      pos: pos
    }));
    this.prefetch_page(activity, pos);

  },

  prefetch_page: function (activity, pos) {
    // prefetch the page data in case the user clicks "learn more"
    if (activity.get('page')) {
      this.current_pages[pos] = new Page({ id: this.extract_id(activity.get('page')) });
      var self = this;
      this.current_pages[pos].fetch({ success: function () {
        $('.learn-more', self.activity_details[pos]).removeClass('invisible');
      }, cache: true, expires: 86400 });
    }
  },

  replace_activity: function (e) {
    var pos = $(e.currentTarget).closest('[data-pos]').data('pos');
    this.render_next_activity(pos);
  },

  replace_all_activities: function () {
    for (let i = 0; i < this.activities_per_page; i = i + 1) {
      if ($(this.activity_details[i]).find('.added').length === 0) {
        this.render_next_activity(i);
      }
    }
  },

  add_activity: function (e) {
    e.preventDefault();
    var activity_id = $(e.currentTarget).closest('[data-activity-id]').data('activity-id');
    if (GLOBALS.IS_LAZY_USER) {
      this.register_flyover({
        add_activity_event: e,
        register_activity_id: activity_id
      });
      return;
    }
    var pos = $(e.currentTarget).closest('[data-pos]').data('pos');
    var planned_activity = new PlannedActivity({
      activity: API_PREFIX + window.Urls['tracker_api:api_dispatch_detail']({
        api_name: API_VERSION,
        resource_name: 'activity',
        pk: activity_id,
      }),
      date: this.today
    });
    var that = this;
    planned_activity.save({}, {
      success: function () {
        that.render_added_activity(pos, activity_id, true);
      }
    });

  },

  render_added_activity: function (pos, id, is_new) {
    var activity = this.activity_collection.find({ id: id });
    $(this.activity_details[pos]).html(this.activity_detail_added_tmpl({
      activity: activity,
      pos: pos
    }));
    this.filtered_activities = _.reject(
      this.filtered_activities, function (item) { return item.get('id') == id; });

    this.prefetch_page(activity, pos);

    // If we have 3 selected activities, disable the replace all and congratulate
    if ($('.added', this.choose_activities_section).length >= this.activities_per_page) {
      this.replace_all.addClass('disabled');
      if (is_new) {
        this.planned_3_modal.modal('show');
      }
    }
  },

  learn_more_flyover: function (e) {
    var activity_id = $(e.currentTarget).closest('[data-activity-id]').data('activity-id');
    var activity = this.activity_collection.find({ id: activity_id });
    var group = this.activity_group_collection.findWhere({ resource_uri: activity.get('group') });
    var pos = $(e.currentTarget).closest('[data-pos]').data('pos');
    this.flyover.html(this.activity_flyover_tmpl({
      activity: activity,
      group: group,
      page: this.current_pages[pos]
    }));
    _.each($('.video-embed', self.flyover), function (video_el) {
      new Video({ el: $(video_el) });
    });
    this.flyover.addClass('in');
  },

  register_flyover: function (options) {
    this.flyover.html(this.register_flyover_tmpl());
    new Register(_.extend({
      el: $('#register-flow', this.flyover),
    }, options))
      .on('registered', function () {
        this.add_activity(options.add_activity_event);
      }, this)
      .on('removing', this.close_flyover)
      .render();
    this.flyover.addClass('in');
  },

  get_reminders: function () {
    this.planned_3_modal.modal('hide');
    this.register_flyover({
      profile: this.profile,
      starting_slide: 1
    });

  },

  close_flyover: function (e) {
    if (e) {
      e.preventDefault();
    }
    this.flyover.removeClass('in');
  }

});



// WEBPACK FOOTER //
// ./static/js/views/exercises.js